export default __webpack_public_path__ + "static/ppspunbond-36816e33071842dfd26f0faf20f2e07f.jpg";